<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- G100系共通部品_Steps -->
    <app-g100-steps></app-g100-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label *ngIf="!confirmationFlag">お知らせの登録</label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- お知らせ登録(G103)) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="g103InputForm">
        <!-- お知らせ情報 -->
        <div class="information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
              <label class="warning">【必須】の項目は入力必須項目です。必ずご記載ください。
              </label>
            </label>
          </div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>お知らせの概要</h2>
          </div>
          <!-- お知らせ情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- お知らせ区分 -->
              <tr>
                <td class="item-name">
                  お知らせ区分
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <p-dropdown [options]="getDicList(1004)" optionLabel="sp_name" optionValue="sp_code"
                    placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                    formControlName="information_kbn"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('information_kbn')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 見出し -->
              <tr>
                <td class="item-name">見出し</td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="head" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('head')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- タイトル -->
              <tr>
                <td class="item-name">
                  タイトル
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="title" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('title')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 掲載URL -->
              <tr>
                <td class="item-name">掲載URL</td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="url" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 掲載開始日 -->
              <tr>
                <td class="item-name">
                  掲載開始日
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <p-calendar [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true"
                    placeholder="例）2023/03/31" dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                    yearRange="2000:2999" formControlName="publishe_start" translate></p-calendar>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('publishe_start')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 掲載終了日 -->
              <tr>
                <td class="item-name">
                  掲載終了日
                  <span class="required">【必須】</span>
                </td>
                <td class="item-information">
                  <p-calendar [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true"
                    placeholder="例）2023/03/31" dateFormat="yy/mm/dd" dataType="string" appendTo="body"
                    yearRange="2000:2999" formControlName="publishe_end" translate></p-calendar>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('publishe_end')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- お知らせ内容 -->
              <tr>
                <td class="item-name">
                  お知らせ内容
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="information_detail"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="g103InputForm.get('information_detail')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!g103InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="g103InputForm.valid">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア [disabled]="!g103InputForm.valid"-->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1"
          [disabled]="!g103InputForm.valid" (click)="moveG104()"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- お知らせ登録確認(G104)) -->
    <div *ngIf="confirmationFlag">
      <!-- お知らせ情報 -->
      <div class="subcommittee-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録する」ボタンを押して下さい。
        </div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>お知らせの概要</h2>
        </div>
        <!-- お知らせ情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- お知らせ区分 -->
            <tr>
              <td class="item-name">
                お知らせ区分
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ getDicName(1004, g103InputForm.value.information_kbn) }}
              </td>
            </tr>
            <!-- 見出し -->
            <tr>
              <td class="item-name">見出し</td>
              <td class="item-information">
                {{ g103InputForm.value.head }}
              </td>
            </tr>
            <!-- タイトル -->
            <tr>
              <td class="item-name">
                タイトル
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ g103InputForm.value.title }}
              </td>
            </tr>
            <!-- 掲載URL -->
            <tr>
              <td class="item-name">掲載URL</td>
              <td class="item-information">
                {{ g103InputForm.value.url }}
              </td>
            </tr>
            <!-- 掲載開始日 -->
            <tr>
              <td class="item-name">
                掲載開始日
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ g103InputForm.value.publishe_start }}
              </td>
            </tr>
            <!-- 掲載終了日 -->
            <tr>
              <td class="item-name">
                掲載終了日
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ g103InputForm.value.publishe_end }}
              </td>
            </tr>
            <!-- お知らせ内容 -->
            <tr>
              <td class="item-name">
                お知らせ内容
              </td>
              <td class="item-information">
                {{ g103InputForm.value.information_detail }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="登録する" class="button-default-size button1" (click)="moveG105()"></button>
        <button pButton type="button" label="修正する" class="button-default-size button2" (click)="moveG103()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>